import React from 'react'
import PrintComponent from '../../print/Packinglist'

const Shipping = () => {
  return (
    <div><PrintComponent /></div>
  )
}

export default Shipping